import { useCompetitorKeywords } from '../../hooks/useCompetitiveData'

interface KeywordOverlapTableProps {
  competitorId: number
}

function shareClass(value: number): string {
  if (value > 20) return 'text-red-600'
  if (value >= 10) return 'text-amber-600'
  return 'text-slate-500'
}

function formatShare(value: number): string {
  return `${value.toFixed(1)}%`
}

export default function KeywordOverlapTable({ competitorId }: KeywordOverlapTableProps) {
  const { data, isLoading, error } = useCompetitorKeywords(competitorId)
  const keywords = data?.keywords ?? []
  const errorMessage = error instanceof Error ? error.message : null

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-600">Keyword Overlap</h3>

      {errorMessage && (
        <div className="mt-3 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700">{errorMessage}</div>
      )}

      {isLoading ? (
        <div className="mt-3 rounded-md border border-slate-200 bg-slate-50 p-3 text-sm text-slate-600">Loading keyword overlap...</div>
      ) : keywords.length === 0 ? (
        <div className="mt-3 rounded-md border border-slate-200 bg-slate-50 p-3 text-sm text-slate-600">
          No keyword overlap detected.
        </div>
      ) : (
        <div className="mt-3 overflow-x-auto">
          <table className="w-full min-w-[460px] text-sm">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-3 py-2 text-left font-semibold text-slate-600">Keyword</th>
                <th className="px-3 py-2 text-right font-semibold text-slate-600">Buttah share %</th>
                <th className="px-3 py-2 text-right font-semibold text-slate-600">Competitor share %</th>
              </tr>
            </thead>
            <tbody>
              {keywords.map((row) => (
                <tr key={row.keyword} className="border-b border-slate-100">
                  <td className="px-3 py-2 text-slate-800">{row.keyword}</td>
                  <td className="px-3 py-2 text-right text-slate-600">{formatShare(row.buttah_share_pct)}</td>
                  <td className={`px-3 py-2 text-right font-semibold ${shareClass(row.competitor_share_pct)}`}>
                    {formatShare(row.competitor_share_pct)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
